import axios from '@/libs/axios'

export const getUserLinkedBy = (params) => {
  return new Promise((resolve, reject) => {
    axios.get(`userGetLinked`, { params: params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
